<template>
  <div class="form">
    <div class="form__header">
      <h3>Поставили лайк</h3>
    </div>

    <div class="form__body">  
      <ul class="like-list">
        <li v-for="user in data" :key="user.id">
          <span>{{ user.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

